import type { MouseEvent } from 'react';

/** Windows Ctrl 또는 macOS Cmd */
export function isCtrlOrMetaClick(e: MouseEvent): boolean {
  return e.ctrlKey || e.metaKey;
}

export function isContiguousBlock(
  minIdx: number,
  maxIdx: number,
  idSet: Set<string>,
  workList: { id: string }[]
): boolean {
  for (let i = minIdx; i <= maxIdx; i++) {
    if (!idSet.has(workList[i].id)) return false;
  }
  return true;
}

export function isTypingKeyTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  return target.isContentEditable;
}

/** 리스트는 위·아래 1칸, 그리드는 좌우 1칸·상하 `gridCols`칸. 범위 밖이면 null. */
export function nextWorkIndexForArrow(
  activeIndex: number,
  key: string,
  length: number,
  gridCols: number,
): number | null {
  if (length === 0) return null;
  if (activeIndex < 0) {
    if (key === 'ArrowRight' || key === 'ArrowDown') return 0;
    if (key === 'ArrowLeft' || key === 'ArrowUp') return length - 1;
    return null;
  }

  let next = activeIndex;
  if (gridCols > 1) {
    switch (key) {
      case 'ArrowLeft':
        next = activeIndex - 1;
        break;
      case 'ArrowRight':
        next = activeIndex + 1;
        break;
      case 'ArrowUp':
        next = activeIndex - gridCols;
        break;
      case 'ArrowDown':
        next = activeIndex + gridCols;
        break;
      default:
        return null;
    }
  } else {
    switch (key) {
      case 'ArrowDown':
        next = activeIndex + 1;
        break;
      case 'ArrowUp':
        next = activeIndex - 1;
        break;
      default:
        return null;
    }
  }

  if (next < 0 || next >= length) return null;
  return next;
}
